import Vue from 'vue'
import Toasted from 'vue-toasted'

Vue.use(Toasted, {
    iconPack: 'fontawesome',
    duration: 2500
})

// Mensagens padrão
Vue.toasted.register(
    'defaultSuccess',
    payload => !payload.msg ? 'Operação realizada com sucesso!' : payload.msg,
    { type: 'success', icon: 'check' }
)

Vue.toasted.register(
    'defaultError',
    payload => !payload.msg ? 'Opss.. Erro inesperado!' : payload.msg,
    { type: 'error', icon: 'times' }
)

Vue.toasted.register(
    'defaultWarning',
    payload => !payload.msg ? 'Atenção!' : payload.msg,
    { type: 'warning', icon: 'warning' }
)

Vue.toasted.register(
    'defaultInfo',
    payload => !payload.msg ? 'Opa.. Teste executado com sucesso!' : payload.msg,
    { type: 'info', icon: 'check' }
)

